import React from 'react';
import { useTranslation } from 'react-i18next';
import "./reconcile.scss";

function Reconcile() {
  const { t } = useTranslation()

  return (
    <div className='container-reconcile'>
      <div className='texts-reconcile'>
        <h1>{t("data_management.reconcile.title")}</h1>
        <p>{t("data_management.reconcile.section_text_1")}</p>
        <p>{t("data_management.reconcile.section_text_2")}</p>
        <p>{t("data_management.reconcile.section_text_3")}</p>
        <p>{t("data_management.reconcile.section_text_4")}</p>
      </div>
    </div>
  )
}

export default Reconcile;